import { HT, SITE_ORIGIN } from "../siteConfig";
import SEO from "../components/seo.jsx"
import { useEffect, useRef, useState, useCallback } from "react";
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import HeroImg from "../assets/aboutPage.png";
import DoctorPortrait from "../assets/drbhaveshgupta.jpeg";
import Result1Before from "../assets/gallery/patient-3-before.jpg";
import Result1After from "../assets/gallery/patient-3-after.jpg";
import Result2Before from "../assets/gallery/patient-5-before.jpg";
import Result2After from "../assets/gallery/patient-5-after.jpg";
import Result3Before from "../assets/gallery/patient-7-before.jpg";
import Result3After from "../assets/gallery/patient-7-after.jpg";

gsap.registerPlugin(ScrollTrigger);
const cinzel = { fontFamily: "'Cinzel', serif" };


const indiaLocationGroups = [
  {
    title: "North India",
    locations: [
      { name: "Delhi", slug: "delhi" },
      { name: "Gurugram", slug: "gurugram" },
      { name: "Noida", slug: "noida" },
      { name: "Faridabad", slug: "faridabad" },
      { name: "Chandigarh", slug: "chandigarh" },
      { name: "Ludhiana", slug: "ludhiana" },
      { name: "Amritsar", slug: "amritsar" },
      { name: "Jaipur", slug: "jaipur" },
      { name: "Jodhpur", slug: "jodhpur" },
      { name: "Udaipur", slug: "udaipur" },
      { name: "Lucknow", slug: "lucknow" },
      { name: "Kanpur", slug: "kanpur" },
      { name: "Varanasi", slug: "varanasi" },
      { name: "Agra", slug: "agra" },
      { name: "Dehradun", slug: "dehradun" },
    ],
  },
  {
    title: "West & Central India",
    locations: [
      { name: "Mumbai", slug: "mumbai" },
      { name: "Pune", slug: "pune" },
      { name: "Nagpur", slug: "nagpur" },
      { name: "Nashik", slug: "nashik" },
      {
        name: "Chhatrapati Sambhajinagar (Aurangabad)",
        slug: "chhatrapati-sambhajinagar",
      },
      { name: "Shirdi", slug: "shirdi" },
      { name: "Kolhapur", slug: "kolhapur" },
      { name: "Solapur", slug: "solapur" },
      { name: "Ahmedabad", slug: "ahmedabad" },
      { name: "Surat", slug: "surat" },
      { name: "Vadodara", slug: "vadodara" },
      { name: "Rajkot", slug: "rajkot" },
      { name: "Goa", slug: "goa" },
      { name: "Indore", slug: "indore" },
      { name: "Bhopal", slug: "bhopal" },
    ],
  },
  {
    title: "South India",
    locations: [
      { name: "Bangalore", slug: "bangalore" },
      { name: "Mysuru", slug: "mysuru" },
      { name: "Mangaluru", slug: "mangaluru" },
      { name: "Hubballi", slug: "hubballi" },
      { name: "Chennai", slug: "chennai" },
      { name: "Coimbatore", slug: "coimbatore" },
      { name: "Madurai", slug: "madurai" },
      { name: "Hyderabad", slug: "hyderabad" },
      { name: "Visakhapatnam", slug: "visakhapatnam" },
      { name: "Vijayawada", slug: "vijayawada" },
      { name: "Kochi", slug: "kochi" },
      { name: "Thiruvananthapuram", slug: "thiruvananthapuram" },
    ],
  },
  {
    title: "East India",
    locations: [
      { name: "Kolkata", slug: "kolkata" },
      { name: "Bhubaneswar", slug: "bhubaneswar" },
      { name: "Patna", slug: "patna" },
      { name: "Ranchi", slug: "ranchi" },
      { name: "Jamshedpur", slug: "jamshedpur" },
      { name: "Raipur", slug: "raipur" },
      { name: "Guwahati", slug: "guwahati" },
      { name: "Siliguri", slug: "siliguri" },
    ],
  },
];


const PAGE = {
  /* ── HERO ── */
  hero: {
    eyebrow: "Hair Transplant",
    heading: HT.inLabel,
    sub: "Affordable cost, world-class expertise and 98.5% success rate India's leading destination for hair restoration.",
  },

  /* ── BREADCRUMB ── */
  breadcrumb: [
    { label: "Home", href: "/" },
    { label: HT.menu, href: null },
    { label: HT.inLabel, href: null },
  ],

  /* ── INTRO ── */
  intro: {
    eyebrow: "Overview",
    heading: `Best Hair Transplant in ${HT.placeName}`,
    paragraphs: [
      `Clinique Internationale is a highly esteemed hair transplant centre in ${HT.placeName}. Guided by Dr. Bhavesh Gupta, a renowned hair transplant specialist and owner of the Clinique Internationale Hair Transplant Center.`,
      "Hair loss is a common problem that affects millions of people worldwide, regardless of age or gender. Symptoms may include gradual thinning on top of the head and patchy bald spots across the scalp.",
      "Hair transplantation is a medical treatment for hair loss or baldness. During this surgery, healthy hair follicles are removed from the back or sides of the scalp and implanted into bald or thinning regions restoring hair in both men and women suffering from pattern baldness.",
    ],
    stats: [
      { val: "98.5%", sub: "Success rate in India" },
      { val: "10,000+", sub: "Cases by Dr. Bhavesh Gupta" },
      { val: "₹60K+", sub: "Starting cost" },
      { val: "4", sub: "Clinic locations across India" },
    ],
    doctor: {
      name: "Dr. Bhavesh Gupta",
      quote:
        "Choosing a hair transplant requires careful consideration of the surgeon's expertise. This intricate procedure requires a unique combination of surgical and creative abilities particularly in creating a seamless hairline and achieving dense, natural-looking results.",
    },
  },

  /* ── HIGHLIGHT CARD (optional dark full-width card) ── */
  highlight: {
    image: DoctorPortrait,
    eyebrow: "Lead Surgeon",
    heading: `Best Hair Transplant Surgeon in ${HT.placeName}`,
    subheading: "DR. BHAVESH GUPTA",
    role: "Facial Cosmetic and Hair Transplant Surgeon",
    body: [
      "Dr. Bhavesh Gupta holds a Master's in Dentistry and an Advanced Fellowship in Cosmetic Surgery, with over 15 years of experience in Hair Transplant Surgery. He received the prestigious \"Surgery Mentor\" Award at DPT in 2015.",
      "Renowned for his excellence in hair transplant surgery, Dr. Gupta combines his extensive education and hands-on experience to provide patients with top-tier care and transformative results.",
      "At Clinique Internationale, Dr. Gupta's commitment to precision and innovation ensures that each patient receives personalised treatment backed by a track record of successful procedures and satisfied patients.",
    ],
    tags: [ "Fellowship Cosmetic Surgery", "AOMSI MEMBER", "15+ Yrs", "10,000+ Cases"],
    statsGrid: [
      { val: "15+", sub: "Years experience" },
      { val: "10,000+", sub: "Procedures performed" },
      { val: "4", sub: "Clinic locations" },
      { val: "98.5%", sub: "Graft survival rate" },
    ],
  },

  /* ── COST TABLE ── */
  costSection: {
    eyebrow: "Pricing",
    heading: `Best Hair Transplant Cost in ${HT.placeName}`,
    intro:
      "India stands out for budget-friendly hair transplantation. The cost at Clinique Internationale starts from ₹60,000 to ₹5,00,000 ($800–$7,000). On a per-graft basis: ₹40 to ₹100 ($0.5–$1.2).",
    tableHeads: ["Centre", "Grafts", "Average Cost"],
    tableRows: [
      {
        label: "Shirdi",
        href: "https://shirdi.hairclinique.in/",
        grafts: "500–2000",
        cost: "₹50,000 – ₹1,70,000",
        usd: "599–2037 USD",
      },
      {
        label: "Mumbai",
        href: "/",
        grafts: "500–2500",
        cost: "₹50,000 – ₹2,00,000",
        usd: "605–2499 USD",
      },
      {
        label: "Pune",
        href: "https://pune.hairclinique.in/",
        grafts: "500–3000",
        cost: "₹60,000 – ₹2,50,000",
        usd: "729–3199 USD",
      },
      {
        label: "Bangalore",
        href: "https://bangalore.hairclinique.in/",
        grafts: "500–3500",
        cost: "₹70,000 – ₹3,00,000",
        usd: "849–3699 USD",
      },
    ],
    costFactors: [
      { title: "Clinic Reputation", desc: "Clinics with a positive, long-standing reputation often set higher prices than newer or lower-profile centres." },
      { title: "Surgeon's Experience", desc: "Surgeons with extensive experience and specialised expertise may command a higher fee for their services." },
      { title: "Technique Used", desc: "FUE, being a more advanced and less invasive technique, generally tends to be more expensive than FUT." },
      { title: "Number of Grafts", desc: "The total number of grafts required for the transplant directly impacts the overall cost of the procedure." },
    ],
  },

  /* ── TECHNIQUES ── */
  techniques: [
    {
      num: "01",
      title: "Follicular Unit Extraction (FUE)",
      href: "/follicular-unit-extraction.php",
      body: "FUE is a hair transplantation technique where the surgeon extracts follicular units from the donor region individually. Ideal for patients who prefer wearing their hair short, and for those with a tight scalp. Post-FUE scarring is minimal and hardly noticeable.",
      points: [
        "Less invasive strategy than FUT",
        "Minimal discomfort patient returns to work the next day",
        "No linear scars on the back of the head",
        "Ideal for both early and late stages of baldness",
        "Beard and chest grafts can also be extracted",
      ],
    },
    {
      num: "02",
      title: "Follicular Unit Transplantation (FUT)",
      href: "/follicular-unit-transplant.php",
      body: "FUT (strip technique) involves harvesting a strip from the donor area. Single follicles are separated and implanted into the balding region. FUT yields super-intact hair follicles and is excellent for transplanting large numbers of follicles in a single session.",
      points: [
        "Hair roots taken from the most permanent hair-bearing region",
        "Large number of follicles transplantable in one session",
        "Super-intact follicles no machine involved in harvesting",
        "Beard and chest grafts can also be extracted",
      ],
    },
    {
      num: "03",
      title: "DHI (Direct Hair Implantation)",
      href: null,
      body: "DHI is a specialised FUE technique using a Choi Implanter Pen to implant extracted follicles directly into the recipient area without pre-made recipient sites. Research shows that leading clinics worldwide still favour manual methods for superior density and customisation.",
      points: [],
    },
    {
      num: "04",
      title: "Robotic Hair Transplantation",
      href: null,
      body: "Robotic hair transplantation uses advanced technology to extract and transplant follicles. Density achieved with robotic transplants is currently lower than traditional methods. It is still an evolving science. Scalp Micro Pigmentation (SMP) is also available as a non-surgical camouflage option.",
      points: [],
    },
  ],

  /* ── TREATMENTS LIST ── */
  treatments: [
    { num: "01", title: "Male Hair Transplant", href: "/male-hair-transplants.php", desc: "Our male hair transplant procedures embody a fusion of cutting-edge technology, expert craftsmanship, and a profound understanding of individualised needs." },
    { num: "02", title: "Female Hair Transplant", href: "/female-hair-transplants.php", desc: "We provide exceptional female hair transplants, acknowledging the unique needs and aesthetic preferences of women seeking hair restoration solutions." },
    { num: "03", title: "Beard Hair Transplant", href: "/beard-hair-transplants.php", desc: "We specialise in intricate beard hair transplants with precision and artistry. Our skilled team ensures natural results that complement your facial features." },
    { num: "04", title: "Eyebrow Hair Transplant", href: "/eyebrow-hair-transplants.php", desc: "Our eyebrow hair transplant redefines aesthetics. With precision and artistry, we restore and enhance eyebrows ensuring natural results that complement facial features." },
    { num: "05", title: "Eyelash Hair Transplant", href: "/eyelash-hair-transplants.php", desc: "Our eyelash hair transplant focuses on producing realistic outcomes by seamlessly integrating the transplant into existing eyelashes, elevating the overall aesthetic." },
  ],

  /* ── PROCEDURE STEPS ── */
  steps: [
    { num: "01", title: "Scalp Preparation", desc: "The donor and recipient areas are trimmed, cleaned, marked and numbed with local anaesthesia all performed in a highly sterile manner." },
    { num: "02", title: "Recipient Area Preparation", desc: "The surgeon draws an outline of the desired hairline and makes micro-incisions in the scalp using specialised instruments." },
    { num: "03", title: "Graft Harvesting", desc: "Hair follicles are removed using a FUE punch (0.8–1.0mm). PRP or Hypothermosol is used to nourish weak grafts until implantation." },
    { num: "04", title: "Graft Implantation", desc: "The team carefully transplants follicles into microincisions, mimicking natural hair growth patterns. Magnification is used at every step." },
    { num: "05", title: "Post-Surgery Care", desc: "DOs and DONTs are explained. Antibiotics, painkillers, and antacids are prescribed. Hair care products are recommended for optimal regrowth." },
  ],

  /* ── WHY INDIA ── */
  whyIndia: [
    { title: "Cost-Effective Treatment", desc: "Hair transplant in India is significantly lower in cost than USA, UK or Australia at on-par or better quality, due to lower labour costs, rentals, and currency rates." },
    { title: "World-Class Quality", desc: "India has a well-established medical infrastructure with highly skilled surgeons trained at top global institutions. The quality is at par with international standards." },
    { title: "Advanced Techniques", desc: "India offers FUE, FUT, DHI, and Sapphire FUE all minimally invasive and delivering excellent, natural-looking results." },
    { title: "Minimal Waiting Time", desc: "Unlike other countries where you may wait months, we schedule your hair transplant surgery within a few weeks of your inquiry." },
    { title: "Skilled Technicians", desc: "Independent studies show hair transplant is 98.5% successful in India vs 97.1% in Turkey making India the global leader in the art of hair transplants." },
    { title: "High Success Rate", desc: "Both FUE and FUT are effective when chosen at the right stage of baldness. The achievement rate ranges from 97–100%, with natural and permanent results." },
  ],

  /* ── PROS & CONS ── */
  prosAndCons: {
    pros: [
      { title: "Permanent Solution", desc: "Once transplanted hair takes root, it typically continues to grow naturally for life." },
      { title: "Natural Results", desc: "Modern FUT and FUE techniques achieve natural-looking results by transplanting follicles one at a time, mimicking natural growth patterns." },
      { title: "Improved Self-Esteem", desc: "Restoring a fuller head of hair significantly boosts self-confidence and quality of life." },
      { title: "Low Maintenance", desc: "Transplanted hair requires minimal maintenance it can be washed, cut and styled just like natural hair." },
      { title: "Cost-Effective Long-Term", desc: "Compared to ongoing medications or topical solutions, a hair transplant is highly cost-effective over the long term." },
    ],
    cons: [
      { title: "Upfront Cost", desc: "Procedures can be expensive, especially when multiple sessions are necessary to achieve desired results." },
      { title: "Surgical Risks", desc: "Like any surgery, hair transplant carries risks infection, bleeding, scarring, or allergic reaction to anaesthesia." },
      { title: "Risk of Unsatisfactory Results", desc: "There is a risk of unnatural-looking hairlines, patchy growth, or insufficient density if not performed correctly." },
      { title: "Temporary Shedding", desc: "Transplanted hair sheds temporarily before re-growing. This shedding phase can be distressing for some patients." },
      { title: "Time-Consuming", desc: "Procedures can require several hours or multiple sessions depending on the extent of hair loss and technique used." },
    ],
  },

  /* ── POST-TRANSPLANT EXPECTATIONS ── */
  expectations: [
    "After the third month, you will experience a natural-looking hairline and dense hair growth that grows like natural hair, which you can style as per your wish.",
    "If you have a particular hairstyle in mind, convey it to your surgeon on the day of consultation so hair channels can be made accordingly.",
    "Best and cost-effective hair transplantation is provided as per the amenities opted by the patient.",
    "Get back your lost confidence as you feel more self-compliant with your new natural hair look.",
  ],

  /* ── SUCCESSFUL RESULTS / BEFORE-AFTER ── */
  results: {
    eyebrow: "Success Stories",
    heading: "Successful Results of Hair Transplant",
    sub: "Real transformations from real patients at Clinique Internationale genuine before and after outcomes achieved under Dr. Bhavesh Gupta's care.",
    cases: [
      {
        beforeImg: Result1Before,
        afterImg: Result1After,
        name: "Akhil Mahajan",
        grafts: "2200 Grafts · FUE",
        months: "12 Month Result",
        rating: 5,
        review: "The hairline looks completely natural. Nobody at work even suspected I'd had a transplant done.",
      },
      {
        beforeImg: Result2Before,
        afterImg: Result2After,
        name: "Azad",
        grafts: "3000 Grafts · FUT",
        months: "10 Month Result",
        rating: 5,
        review: "Dr. Gupta and his team were transparent through every step. The density I have now exceeded my expectations.",
      },
      {
        beforeImg: Result3Before,
        afterImg: Result3After,
        name: "Karan",
        grafts: "1800 Grafts · DHI",
        months: "14 Month Result",
        rating: 5,
        review: "Minimal downtime and a completely natural-looking result. Best decision I made for my confidence.",
      },
    ],
  },

  /* ── FAQs ── */
  faqs: [
    {
      q: "Which country is better for hair transplants India or Turkey?",
      a: "Turkey was famous for hair transplants but due to unethical practices in many clinics, its image has been degrading. India has taken over the industry, with the added advantage of highly skilled labour at lower costs.",
    },
    {
      q: `Is Hair Transplant Effective in ${HT.placeName}?`,
      a: "Indeed. Mumbai is the city with the best hair transplant clinics. Clinique Internationale offers cutting-edge technologies with practically 100% results. The key is picking the right surgeon for the procedure.",
    },
    {
      q: "Which city in India is best for hair transplant?",
      a: "Mumbai is the most famous city. Clinique Internationale also operates in Navi Mumbai (Kharghar), known for hair transplant tourism with excellent connectivity, modern infrastructure, and skilled technicians.",
    },
    {
      q: `Is Hair Transplant Safe in ${HT.placeName}?`,
      a: "Yes. Hair transplant is protected by law in India. However, it is mandatory to verify the best specialist and facilities for your wellbeing. Always do your due diligence before finalising a clinic or surgeon.",
    },
    {
      q: "How many grafts are required in a usual hair transplant?",
      a: "It depends on the grade of alopecia, hair thickness, skin quality, doubles/triples in the donor area, and smoking status. A simple estimate: (Alopecia grade × 1000) − 500 grafts.",
    },
    {
      q: "Does hair transplant last forever?",
      a: "Yes. In FUE, only permanent DHT-resistant roots are selected from the donor zone. These do not carry receptors for androgens and remain intact for life. Some physiological thinning is possible but the patient never returns to the original condition.",
    },
    {
      q: "Does hair transplant look normal?",
      a: "Absolutely. Surgery performed by Dr. Bhavesh Gupta consistently achieves completely natural outcomes. The performing surgeon must have artistic sensibility and knowledge of hairline planning principles.",
    },
  ],

  /* ── CTA ── */
  cta: {
    eyebrow: "Take the First Step",
    heading: "Begin Your Hair Restoration Journey",
    sub: "Book a personalised consultation with Dr. Bhavesh Gupta at any of our 5 centres across India and take the first step toward lasting, natural results.",
    primary: { label: "Book Consultation", href: "/khargharNaviMumbai.php" },
    secondary: { label: "View All Treatments", href: "/about-hair-transplants.php" },
  },
};

/* ============================================================
   REUSABLE SUB-COMPONENTS
============================================================ */
function Eyebrow({ children, light = false }) {
  return (
    <p
      style={cinzel}
      className={`text-[10.5px] tracking-[0.28em] uppercase mb-3 flex items-center justify-center gap-2.5 ${light ? "text-[#c9a84c]/70" : "text-[#a07828]"}`}
    >
      <span className={`w-6 h-px ${light ? "bg-[#c9a84c]/50" : "bg-[#c9a84c]"}`} />
      {children}
    </p>
  );
}

function SectionHeading({ children, light = false }) {
  return (
    <h2
      style={cinzel}
      className={`font-black text-[1.3rem] sm:text-[1.6rem] md:text-[1.85rem] text-center uppercase tracking-[0.05em] mb-10 ${light ? "text-white" : "text-[#1a0f02]"}`}
    >
      {children}
    </h2>
  );
}

function GoldDivider() {
  return <div className="w-full h-px bg-gradient-to-r from-transparent via-[#c9a84c]/30 to-transparent" />;
}

function FaqItem({ q, a }) {
  const [open, setOpen] = useState(false);
  return (
    <div className={`border rounded-xl overflow-hidden transition-colors duration-300 ${open ? "border-[#c9a84c]/40 bg-[#c9a84c]/[0.04]" : "border-[#c9a84c]/15 bg-white"}`}>
      <button className="w-full flex items-center justify-between gap-4 px-5 sm:px-6 py-5 text-left" onClick={() => setOpen((p) => !p)}>
        <span style={cinzel} className="text-[13px] font-bold tracking-[0.04em] text-[#1a0f02]">{q}</span>
        <span className={`flex-shrink-0 w-7 h-7 rounded-full border border-[#c9a84c]/35 flex items-center justify-center transition-transform duration-300 ${open ? "rotate-45 bg-[#c9a84c] border-[#c9a84c]" : ""}`}>
          <svg width="12" height="12" viewBox="0 0 12 12" fill="none">
            <path d="M6 2v8M2 6h8" stroke={open ? "#1a0f02" : "#c9a84c"} strokeWidth="1.8" strokeLinecap="round" />
          </svg>
        </span>
      </button>
      {open && (
        <div className="px-5 sm:px-6 pb-5">
          <p className="text-[13.5px] leading-[1.8] text-[#6b5535]">{a}</p>
        </div>
      )}
    </div>
  );
}

function StarRating({ count = 5 }) {
  return (
    <div className="flex items-center gap-0.5">
      {Array.from({ length: 5 }).map((_, i) => (
        <svg key={i} width="13" height="13" viewBox="0 0 24 24" fill={i < count ? "#c9a84c" : "none"}>
          <path
            d="M12 2l3.09 6.26L22 9.27l-5 4.87L18.18 21 12 17.77 5.82 21 7 14.14l-5-4.87 6.91-1.01L12 2z"
            stroke="#c9a84c"
            strokeWidth="1.3"
          />
        </svg>
      ))}
    </div>
  );
}

/* ── Lightbox: full-screen image viewer with prev/next + esc/backdrop close ── */
function ResultLightbox({ items, activeIndex, onClose, onNav }) {
  const isOpen = activeIndex !== null && !!items[activeIndex];

  useEffect(() => {
    if (!isOpen) return; // don't touch scroll/listeners unless actually open

    const onKey = (e) => {
      if (e.key === "Escape") onClose();
      if (e.key === "ArrowRight") onNav(1);
      if (e.key === "ArrowLeft") onNav(-1);
    };
    window.addEventListener("keydown", onKey);
    document.body.style.overflow = "hidden";
    return () => {
      window.removeEventListener("keydown", onKey);
      document.body.style.overflow = "";
    };
  }, [isOpen, onClose, onNav]);

  if (!isOpen) return null;
  const item = items[activeIndex];

  return (
    <div
      className="fixed inset-0 z-[999] bg-[#0e0905]/95 flex items-center justify-center px-4 sm:px-8"
      onClick={onClose}
      role="dialog"
      aria-modal="true"
    >
      {/* close button */}
      <button
        onClick={onClose}
        aria-label="Close"
        className="absolute top-5 right-5 sm:top-7 sm:right-7 w-10 h-10 rounded-full border border-[#c9a84c]/30 flex items-center justify-center text-[#c9a84c] hover:bg-[#c9a84c]/10 transition-colors z-10"
      >
        <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
          <path d="M2 2l12 12M14 2L2 14" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" />
        </svg>
      </button>

      {/* prev */}
      <button
        onClick={(e) => { e.stopPropagation(); onNav(-1); }}
        aria-label="Previous"
        className="absolute left-3 sm:left-8 top-1/2 -translate-y-1/2 w-11 h-11 rounded-full border border-[#c9a84c]/30 flex items-center justify-center text-[#c9a84c] hover:bg-[#c9a84c]/10 transition-colors z-10"
      >
        <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
          <path d="M10 2L4 8l6 6" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
      </button>

      {/* next */}
      <button
        onClick={(e) => { e.stopPropagation(); onNav(1); }}
        aria-label="Next"
        className="absolute right-3 sm:right-8 top-1/2 -translate-y-1/2 w-11 h-11 rounded-full border border-[#c9a84c]/30 flex items-center justify-center text-[#c9a84c] hover:bg-[#c9a84c]/10 transition-colors z-10"
      >
        <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
          <path d="M6 2l6 6-6 6" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
      </button>

      {/* content */}
      <div
        className="relative max-w-3xl w-full flex flex-col items-center"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="relative w-full rounded-2xl overflow-hidden border border-[#c9a84c]/25">
          <img
            src={item.src}
            alt={`${item.name} ${item.label}`}
            className="w-full max-h-[70vh] object-contain bg-[#0e0905]"
          />
          <span
            style={cinzel}
            className={`absolute top-4 left-4 text-[10px] tracking-[0.15em] uppercase px-3 py-1.5 rounded font-bold ${
              item.label === "Before" ? "bg-[#0e0905]/85 text-white/85" : "bg-[#c9a84c] text-[#1a0f02]"
            }`}
          >
            {item.label}
          </span>
        </div>
        <div className="mt-4 text-center">
          <p style={cinzel} className="text-[13px] font-bold tracking-[0.06em] uppercase text-white">{item.name}</p>
          <p className="text-[11.5px] text-[#c9a84c]/80 mt-1">{item.grafts} · {item.months}</p>
        </div>
      </div>
    </div>
  );
}

function ResultCard({ r, onImageClick }) {
  return (
    <div className="bg-white border border-[#c9a84c]/18 rounded-2xl overflow-hidden relative hover:-translate-y-1.5 hover:shadow-[0_12px_32px_rgba(90,60,10,0.1)] transition-all duration-300">
      <span className="absolute top-0 left-4 right-4 h-px bg-gradient-to-r from-transparent via-[#c9a84c]/40 to-transparent z-10" />
      <div className="grid grid-cols-2">
        <button
          type="button"
          onClick={() => onImageClick(0)}
          className="relative cursor-zoom-in group"
          aria-label={`View ${r.name} before photo full size`}
        >
          <img src={r.beforeImg} alt={`${r.name} before hair transplant`} className="w-full h-44 sm:h-52 object-cover" />
          <div className="absolute inset-0 bg-[#0e0905]/0 group-hover:bg-[#0e0905]/15 transition-colors" />
          <span style={cinzel} className="absolute bottom-2 left-2 text-[9px] tracking-[0.15em] uppercase bg-[#0e0905]/80 text-white/80 px-2.5 py-1 rounded">
            Before
          </span>
        </button>
        <button
          type="button"
          onClick={() => onImageClick(1)}
          className="relative cursor-zoom-in group"
          aria-label={`View ${r.name} after photo full size`}
        >
          <img src={r.afterImg} alt={`${r.name} after hair transplant`} className="w-full h-44 sm:h-52 object-cover" />
          <div className="absolute inset-0 bg-[#0e0905]/0 group-hover:bg-[#0e0905]/15 transition-colors" />
          <span style={cinzel} className="absolute bottom-2 left-2 text-[9px] tracking-[0.15em] uppercase bg-[#c9a84c] text-[#1a0f02] px-2.5 py-1 rounded font-bold">
            After
          </span>
        </button>
      </div>
      <div className="p-6">
        <div className="flex items-center justify-between mb-2.5 gap-2">
          <p style={cinzel} className="text-[12.5px] font-bold tracking-[0.05em] uppercase text-[#1a0f02]">{r.name}</p>
          <StarRating count={r.rating} />
        </div>
        <div className="flex flex-wrap gap-2 mb-3">
          <span style={cinzel} className="text-[9.5px] tracking-[0.1em] uppercase text-[#a07828] border border-[#c9a84c]/25 rounded px-2.5 py-1">{r.grafts}</span>
          <span style={cinzel} className="text-[9.5px] tracking-[0.1em] uppercase text-[#a07828] border border-[#c9a84c]/25 rounded px-2.5 py-1">{r.months}</span>
        </div>
        <p className="text-[13px] italic leading-[1.75] text-[#6b5535]">"{r.review}"</p>
      </div>
    </div>
  );
}

/* ============================================================
   PAGE COMPONENT DO NOT EDIT BELOW THIS LINE
============================================================ */
export default function ServicePage() {
  const pageRef       = useRef(null);
  const heroEyeRef    = useRef(null);
  const heroHeadRef   = useRef(null);
  const heroSubRef    = useRef(null);
  const sectionRefs   = useRef([]);
  const addSection    = (el) => el && !sectionRefs.current.includes(el) && sectionRefs.current.push(el);

  /* flatten all before/after images into a single ordered list for the lightbox,
     so prev/next can move seamlessly across cards */
  const lightboxItems = PAGE.results.cases.flatMap((r) => [
    { src: r.beforeImg, label: "Before", name: r.name, grafts: r.grafts, months: r.months },
    { src: r.afterImg, label: "After", name: r.name, grafts: r.grafts, months: r.months },
  ]);
  const [activeIndex, setActiveIndex] = useState(null);

  const openLightbox = (caseIdx, imgIdx) => setActiveIndex(caseIdx * 2 + imgIdx);
  const closeLightbox = useCallback(() => setActiveIndex(null), []);
  const navLightbox = useCallback(
    (dir) => setActiveIndex((prev) => (prev === null ? null : (prev + dir + lightboxItems.length) % lightboxItems.length)),
    [lightboxItems.length]
  );

  useEffect(() => {
    const ctx = gsap.context(() => {
      const ease = "power3.out";
      gsap.fromTo(heroEyeRef.current,  { opacity: 0, y: 20 }, { opacity: 1, y: 0, duration: 0.7, ease });
      gsap.fromTo(heroHeadRef.current, { opacity: 0, y: 26 }, { opacity: 1, y: 0, duration: 0.75, ease, delay: 0.1 });
      gsap.fromTo(heroSubRef.current,  { opacity: 0, y: 22 }, { opacity: 1, y: 0, duration: 0.7, ease, delay: 0.18 });

      sectionRefs.current.forEach((el) => {
        if (!el) return;
        gsap.fromTo(el,
          { opacity: 0, y: 36 },
          { opacity: 1, y: 0, duration: 0.75, ease,
            scrollTrigger: { trigger: el, start: "top 88%", toggleActions: "play none none reverse" } }
        );
      });
    }, pageRef);
    return () => ctx.revert();
  }, []);

  const wrap = "max-w-6xl mx-auto px-5 sm:px-8 lg:px-12";
  const sec  = "py-16 sm:py-20 md:py-24";

  return (
    <>
    <SEO
  title={`Hair Transplant in ${HT.placeName}: Affordable Cost, Expert Surgeon`}
  description={`Get affordable, expert hair transplant in ${HT.placeName} at Clinique Internationale with Dr. Bhavesh Gupta. Advanced FUE/FUT techniques, natural, lasting results.`}
  url={`${SITE_ORIGIN}${HT.inPath}`}
/>
      <link href="https://fonts.googleapis.com/css2?family=Cinzel:wght@400;600;700;900&family=Raleway:ital,wght@0,300;0,400;0,500;0,600;1,300;1,400&display=swap" rel="stylesheet" />

<div ref={pageRef} className="relative w-full bg-[#f2ece0] overflow-hidden mt-16 lg:mt-20" style={{ fontFamily: "'Raleway', sans-serif" }}>

  {/* ══════════════════════════════════════
      HERO
  ══════════════════════════════════════ */}
  <div className="relative h-[200px] xs:h-[280px] sm:h-[340px] md:h-[700px] flex items-center justify-end overflow-hidden">
    <img className="absolute inset-0 w-full h-full object-cover object-[center_20%]" src={HeroImg} alt={PAGE.hero.heading} />
    <div className="absolute inset-0" />
    <div className="absolute inset-0 opacity-40 pointer-events-none"
      style={{ backgroundImage: "url(\"data:image/svg+xml,%3Csvg viewBox='0 0 200 200' xmlns='http://www.w3.org/2000/svg'%3E%3Cfilter id='n'%3E%3CfeTurbulence type='fractalNoise' baseFrequency='0.75' numOctaves='4' stitchTiles='stitch'/%3E%3C/filter%3E%3Crect width='100%25' height='100%25' filter='url(%23n)' opacity='0.04'/%3E%3C/svg%3E\")" }}
    />
    <div className="relative z-10 text-right px-4 sm:px-10 md:px-16 max-w-[85%] sm:max-w-xl">
      <p ref={heroEyeRef} style={cinzel} className="text-[8px] xs:text-[9px] sm:text-[10.5px] tracking-[0.2em] xs:tracking-[0.24em] sm:tracking-[0.32em] uppercase text-[#c9a84c] mb-2 sm:mb-4 flex items-center justify-end gap-2 sm:gap-3">
        <span className="w-4 sm:w-7 h-px bg-[#c9a84c]" />{PAGE.hero.eyebrow}<span className="w-4 sm:w-7 h-px bg-[#c9a84c]" />
      </p>
      <h1 ref={heroHeadRef} style={cinzel} className="font-black text-[0.8rem] xs:text-[1.8rem] sm:text-[2.8rem] md:text-[3.6rem] tracking-[0.02em] sm:tracking-[0.04em] uppercase text-white mb-2 sm:mb-3 leading-[1.15] sm:leading-tight">
        {PAGE.hero.heading}
      </h1>
      <p ref={heroSubRef} className="text-[11px] xs:text-[12px] sm:text-[15px] text-white/70 leading-relaxed ml-auto">{PAGE.hero.sub}</p>
    </div>
  </div>

        {/* ── BREADCRUMB ── */}
        <div className="bg-[#0e0905]/95 border-b border-[#c9a84c]/10">
          <div className={`${wrap} py-3 flex flex-wrap items-center gap-2`}>
            {PAGE.breadcrumb.map((b, i) => (
              <span key={i} className="flex items-center gap-2">
                {i > 0 && <span className="text-[#c9a84c]/30 text-xs">›</span>}
                {b.href
                  ? <a href={b.href} style={cinzel} className="text-[10px] tracking-widest uppercase text-[#c9a84c]/60 hover:text-[#c9a84c] transition-colors">{b.label}</a>
                  : <span style={cinzel} className="text-[10px] tracking-widest uppercase text-[#c9a84c]">{b.label}</span>}
              </span>
            ))}
          </div>
        </div>

        {/* ══════════════════════════════════════
            INTRO text + stats card + doctor quote
        ══════════════════════════════════════ */}
        <div className={`${wrap} ${sec}`}>
          <div ref={addSection} className="grid grid-cols-1 md:grid-cols-2 gap-10 md:gap-16 items-start">
            {/* LEFT */}
            <div>
              <Eyebrow>{PAGE.intro.eyebrow}</Eyebrow>
              <h2 style={cinzel} className="font-black text-[1.55rem] sm:text-[1.85rem] md:text-[2.1rem] tracking-[0.03em] uppercase text-[#1a0f02] leading-tight mb-6 text-center md:text-left">
                {PAGE.intro.heading}
              </h2>
              {PAGE.intro.paragraphs.map((p, i) => (
                <p key={i} className="text-[14.5px] leading-[1.9] text-[#3a2e1e] mb-4">{p}</p>
              ))}
            </div>
            {/* RIGHT */}
            <div className="flex flex-col gap-5">
              {/* stats */}
              <div className="relative overflow-hidden bg-[#0e0905] border border-[#c9a84c]/20 rounded-2xl p-7">
                <span className="absolute top-0 inset-x-0 h-px bg-gradient-to-r from-transparent via-[#c9a84c]/50 to-transparent" />
                <p style={cinzel} className="text-[10px] tracking-[0.22em] uppercase text-[#c9a84c]/60 mb-5">At a Glance</p>
                <div className="grid grid-cols-2 gap-5">
                  {PAGE.intro.stats.map((s) => (
                    <div key={s.val}>
                      <div style={cinzel} className="font-black text-[1.6rem] leading-none mb-1 bg-gradient-to-br from-[#c9943a] via-[#ffe9a0] to-[#c9943a] bg-clip-text text-transparent">{s.val}</div>
                      <div className="text-[11.5px] text-white/45 leading-snug">{s.sub}</div>
                    </div>
                  ))}
                </div>
              </div>
              {/* doctor quote */}
              <div className="relative overflow-hidden bg-white border border-[#c9a84c]/20 rounded-2xl p-6">
                <span className="absolute top-0 left-4 right-4 h-px bg-gradient-to-r from-transparent via-[#c9a84c]/40 to-transparent" />
                <div className="flex gap-3 items-start">
                  <div className="w-10 h-10 rounded-full bg-gradient-to-br from-[#c9a84c]/15 to-[#c9a84c]/5 border border-[#c9a84c]/25 flex items-center justify-center flex-shrink-0 mt-0.5">
                    <svg viewBox="0 0 24 24" fill="none" width="18" height="18">
                      <circle cx="12" cy="8" r="4" stroke="#c9a84c" strokeWidth="1.8" fill="none"/>
                      <path d="M4 20c0-4.4 3.6-8 8-8s8 3.6 8 8" stroke="#c9a84c" strokeWidth="1.8" strokeLinecap="round" fill="none"/>
                    </svg>
                  </div>
                  <div>
                    <p style={cinzel} className="text-[11px] font-bold tracking-[0.06em] text-[#1a0f02] mb-1">{PAGE.intro.doctor.name}</p>
                    <p className="text-[12.5px] italic leading-[1.75] text-[#6b5535]">"{PAGE.intro.doctor.quote}"</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* ══════════════════════════════════════
            HIGHLIGHT CARD surgeon / key info
        ══════════════════════════════════════ */}
        <GoldDivider />
        <div className="bg-[#0e0905] py-16 sm:py-20 md:py-24">
          <div className={wrap}>
            <div ref={addSection} className="relative overflow-hidden border border-[#c9a84c]/20 rounded-2xl p-8 sm:p-10 md:p-12"
              style={{ background: "linear-gradient(135deg,rgba(201,168,76,0.07),rgba(201,168,76,0.02))" }}>
              <span className="absolute top-0 inset-x-0 h-px bg-gradient-to-r from-transparent via-[#c9a84c]/50 to-transparent" />
              <div className="grid grid-cols-1 md:grid-cols-2 gap-8 md:gap-12 items-start">
                <div>
                  <Eyebrow light>{PAGE.highlight.eyebrow}</Eyebrow>
                  <h2 style={cinzel} className="font-black text-[2rem] sm:text-[1.7rem] md:text-[2.5rem] text-white uppercase tracking-[0.04em] leading-tight mb-1">{PAGE.highlight.heading}</h2>
                  <p style={cinzel} className="text-[12px] text-[#c9a84c]/80 tracking-[0.08em] mb-1">{PAGE.highlight.subheading}</p>
                  <p className="text-[12px] text-white/50 italic mb-5">{PAGE.highlight.role}</p>
                  {PAGE.highlight.body.map((p, i) => (
                    <p key={i} className="text-[13.5px] leading-[1.85] text-white/60 mb-3">{p}</p>
                  ))}
                  <div className="flex flex-wrap gap-2 mt-4">
                    {PAGE.highlight.tags.map((t) => (
                      <span key={t} style={cinzel} className="text-[9.5px] tracking-[0.12em] uppercase text-[#c9a84c]/90 border border-[#c9a84c]/25 rounded px-3 py-1">{t}</span>
                    ))}
                  </div>
                </div>
                <div className="flex flex-col gap-5">
                  {/* doctor portrait */}
                  <div className="relative rounded-2xl overflow-hidden border border-[#c9a84c]/25">
                    <img
                      src={PAGE.highlight.image}
                      alt={PAGE.highlight.subheading}
                      className="w-full h-auto object-contain object-top"
                    />
                    <div className="absolute inset-0 bg-gradient-to-t from-[#0e0905]/85 via-[#0e0905]/10 to-transparent" />
                    <div className="absolute bottom-4 left-4 right-4">
                      <p style={cinzel} className="text-[13px] font-bold tracking-[0.06em] text-white">{PAGE.highlight.subheading}</p>
                      <p className="text-[11px] text-[#c9a84c]/90 italic">{PAGE.highlight.role}</p>
                    </div>
                  </div>
                  {/* stats grid */}
                  <div className="grid grid-cols-2 gap-4">
                    {PAGE.highlight.statsGrid.map((s) => (
                      <div key={s.val} className="bg-white/[0.04] border border-[#c9a84c]/12 rounded-xl p-5 text-center hover:bg-[#c9a84c]/[0.07] hover:border-[#c9a84c]/25 transition-colors">
                        <div style={cinzel} className="font-black text-[1.5rem] leading-none mb-1 bg-gradient-to-br from-[#c9943a] via-[#ffe9a0] to-[#c9943a] bg-clip-text text-transparent">{s.val}</div>
                        <div className="text-[11px] text-white/45 leading-snug">{s.sub}</div>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <GoldDivider />

        {/* ══════════════════════════════════════
            COST TABLE
        ══════════════════════════════════════ */}
        <div className={`${wrap} ${sec}`}>
          <div ref={addSection}>
            <Eyebrow>{PAGE.costSection.eyebrow}</Eyebrow>
            <SectionHeading>{PAGE.costSection.heading}</SectionHeading>
            <p className="text-[14.5px] leading-[1.9] text-[#3a2e1e] max-w-3xl mx-auto text-center mb-8">{PAGE.costSection.intro}</p>

            {/* table */}
            <div className="overflow-x-auto rounded-2xl border border-[#c9a84c]/20 shadow-[0_4px_24px_rgba(90,60,10,0.07)] mb-10">
              <table className="w-full text-sm">
                <thead>
                  <tr className="bg-[#0e0905]">
                    {PAGE.costSection.tableHeads.map((h) => (
                      <th key={h} style={cinzel} className="text-left text-[11px] tracking-[0.1em] uppercase text-[#c9a84c] px-5 py-4 font-bold">{h}</th>
                    ))}
                    <th style={cinzel} className="text-left text-[11px] tracking-[0.1em] uppercase text-[#c9a84c] px-5 py-4 font-bold">USD Range</th>
                  </tr>
                </thead>
                <tbody>
                  {PAGE.costSection.tableRows.map((r, i) => (
                    <tr key={i} className={`border-t border-[#c9a84c]/10 ${i % 2 === 0 ? "bg-white" : "bg-[#f2ece0]"} hover:bg-[#c9a84c]/[0.05] transition-colors`}>
                      <td className="px-5 py-4">
                        <a href={r.href} style={cinzel} className="text-[12px] font-bold text-[#a07828] hover:text-[#c9a84c] tracking-wide transition-colors">{r.label}</a>
                      </td>
                      <td className="px-5 py-4 text-[13px] text-[#3a2e1e]">{r.grafts}</td>
                      <td className="px-5 py-4 text-[13px] font-semibold text-[#1a0f02]">{r.cost}</td>
                      <td className="px-5 py-4 text-[12px] text-[#6b5535]">{r.usd}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>

            {/* cost factors */}
            <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-5">
              {PAGE.costSection.costFactors.map((f, i) => (
                <div key={i} className="bg-white border border-[#c9a84c]/18 rounded-2xl p-6 relative overflow-hidden hover:-translate-y-1.5 hover:shadow-[0_12px_32px_rgba(90,60,10,0.1)] transition-all duration-300">
                  <span className="absolute top-0 left-4 right-4 h-px bg-gradient-to-r from-transparent via-[#c9a84c]/40 to-transparent" />
                  <div style={cinzel} className="text-[12.5px] font-bold tracking-[0.06em] uppercase text-[#1a0f02] mb-2.5">{f.title}</div>
                  <p className="text-[13px] leading-[1.75] text-[#6b5535]">{f.desc}</p>
                </div>
              ))}
            </div>
          </div>
        </div>

        {/* ══════════════════════════════════════
            TECHNIQUES
        ══════════════════════════════════════ */}
        <GoldDivider />
        <div className="bg-[#faf8f4] py-16 sm:py-20 md:py-24">
          <div className={wrap}>
            <div ref={addSection}>
              <Eyebrow>Methods</Eyebrow>
              <SectionHeading>Techniques of Hair Restoration</SectionHeading>
              <div className="flex flex-col gap-6">
                {PAGE.techniques.map((t) => (
                  <div key={t.num} className="bg-white border border-[#c9a84c]/18 rounded-2xl p-6 sm:p-8 relative overflow-hidden hover:shadow-[0_8px_28px_rgba(90,60,10,0.08)] transition-shadow">
                    <span className="absolute top-0 left-4 right-4 h-px bg-gradient-to-r from-transparent via-[#c9a84c]/40 to-transparent" />
                    <div className="flex gap-5 items-start flex-col sm:flex-row">
                      <span style={cinzel} className="font-black text-[2.4rem] leading-none text-[#c9a84c]/20 select-none flex-shrink-0">{t.num}</span>
                      <div className="flex-1">
                        {t.href
                          ? <a href={t.href} style={cinzel} className="text-[14px] font-bold tracking-[0.05em] uppercase text-[#1a0f02] mb-3 hover:text-[#a07828] transition-colors inline-block">{t.title}</a>
                          : <div style={cinzel} className="text-[14px] font-bold tracking-[0.05em] uppercase text-[#1a0f02] mb-3">{t.title}</div>}
                        <p className="text-[13.5px] leading-[1.85] text-[#6b5535] mb-4">{t.body}</p>
                        {t.points.length > 0 && (
                          <ul className="flex flex-col gap-1.5">
                            {t.points.map((pt, i) => (
                              <li key={i} className="flex items-start gap-2.5 text-[13px] text-[#6b5535]">
                                <span className="w-1.5 h-1.5 rounded-full bg-[#c9a84c] flex-shrink-0 mt-1.5" />
                                {pt}
                              </li>
                            ))}
                          </ul>
                        )}
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
        <GoldDivider />

        {/* ══════════════════════════════════════
            TREATMENTS LIST
        ══════════════════════════════════════ */}
        <div className={`${wrap} ${sec}`}>
          <div ref={addSection}>
            <Eyebrow>Our Services</Eyebrow>
            <SectionHeading>Hair Transplant Treatments at Clinique Internationale</SectionHeading>
            <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-5">
              {PAGE.treatments.map((t) => (
                <a key={t.num} href={t.href}
                  className="bg-white border border-[#c9a84c]/18 rounded-2xl p-6 relative overflow-hidden hover:-translate-y-1.5 hover:shadow-[0_12px_32px_rgba(90,60,10,0.1)] transition-all duration-300 group block">
                  <span className="absolute top-0 left-4 right-4 h-px bg-gradient-to-r from-transparent via-[#c9a84c]/40 to-transparent" />
                  <div className="flex items-center gap-3 mb-3">
                    <span style={cinzel} className="font-black text-[1.5rem] leading-none text-[#c9a84c]/25">{t.num}</span>
                    <div style={cinzel} className="text-[13px] font-bold tracking-[0.05em] uppercase text-[#1a0f02] group-hover:text-[#a07828] transition-colors">{t.title}</div>
                  </div>
                  <p className="text-[13px] leading-[1.75] text-[#6b5535]">{t.desc}</p>
                  <div className="mt-3 flex items-center gap-1.5">
                    <span style={cinzel} className="text-[10px] tracking-widest uppercase text-[#c9a84c] font-bold">Learn More</span>
                    <span className="text-[#c9a84c] text-xs">→</span>
                  </div>
                </a>
              ))}
            </div>
          </div>
        </div>

        {/* ══════════════════════════════════════
            PROCEDURE STEPS dark band
        ══════════════════════════════════════ */}
        <GoldDivider />
        <div className="bg-[#0e0905] py-16 sm:py-20 md:py-24">
          <div className={wrap}>
            <div ref={addSection}>
              <Eyebrow light>How It Works</Eyebrow>
              <SectionHeading light>Procedure of Hair Transplant in {HT.placeName}</SectionHeading>
              <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-5">
                {PAGE.steps.map((s) => (
                  <div key={s.num} className="relative overflow-hidden bg-gradient-to-br from-[#c9a84c]/[0.07] to-[#c9a84c]/[0.02] border border-[#c9a84c]/15 rounded-2xl p-7 hover:border-[#c9a84c]/30 transition-colors">
                    <span className="absolute top-0 inset-x-0 h-px bg-gradient-to-r from-transparent via-[#c9a84c]/35 to-transparent" />
                    <span style={cinzel} className="font-black text-[2.2rem] leading-none text-[#c9a84c]/20 select-none block mb-3">{s.num}</span>
                    <div style={cinzel} className="text-[13px] font-bold tracking-[0.06em] uppercase text-white/90 mb-2.5">{s.title}</div>
                    <p className="text-[13px] leading-[1.8] text-white/55">{s.desc}</p>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
        <GoldDivider />

        {/* ══════════════════════════════════════
            WHY INDIA
        ══════════════════════════════════════ */}
        <div className={`${wrap} ${sec}`}>
          <div ref={addSection}>
            <Eyebrow>Why Choose India</Eyebrow>
            <SectionHeading>Why India is Best for Hair Transplant?</SectionHeading>
            <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-5">
              {PAGE.whyIndia.map((w, i) => (
                <div key={i} className="bg-white border border-[#c9a84c]/18 rounded-2xl p-6 relative overflow-hidden hover:-translate-y-1.5 hover:shadow-[0_12px_32px_rgba(90,60,10,0.1)] transition-all duration-300">
                  <span className="absolute top-0 left-4 right-4 h-px bg-gradient-to-r from-transparent via-[#c9a84c]/40 to-transparent" />
                  <div className="w-10 h-10 rounded-full bg-gradient-to-br from-[#c9a84c]/10 to-[#c9a84c]/[0.03] border border-[#c9a84c]/20 flex items-center justify-center mb-4">
                    <span style={cinzel} className="text-[12px] font-black text-[#c9a84c]">{String(i + 1).padStart(2, "0")}</span>
                  </div>
                  <div style={cinzel} className="text-[12.5px] font-bold tracking-[0.06em] uppercase text-[#1a0f02] mb-2">{w.title}</div>
                  <p className="text-[13px] leading-[1.75] text-[#6b5535]">{w.desc}</p>
                </div>
              ))}
            </div>
          </div>
        </div>

        {/* ══════════════════════════════════════
            PROS & CONS
        ══════════════════════════════════════ */}
        <GoldDivider />
        <div className="bg-[#faf8f4] py-16 sm:py-20 md:py-24">
          <div className={wrap}>
            <div ref={addSection}>
              <Eyebrow>Considerations</Eyebrow>
              <SectionHeading>Advantages &amp; Disadvantages</SectionHeading>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-6 md:gap-8">
                {/* PROS */}
                <div>
                  <div className="flex items-center gap-3 mb-5">
                    <div className="w-8 h-8 rounded-full bg-emerald-50 border border-emerald-200 flex items-center justify-center">
                      <svg width="14" height="14" viewBox="0 0 14 14" fill="none"><path d="M2 7l4 4 6-6" stroke="#16a34a" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/></svg>
                    </div>
                    <span style={cinzel} className="text-[13px] font-bold uppercase tracking-[0.06em] text-[#1a0f02]">Advantages</span>
                  </div>
                  <div className="flex flex-col gap-3">
                    {PAGE.prosAndCons.pros.map((p, i) => (
                      <div key={i} className="bg-white border border-emerald-100 rounded-xl p-4 flex gap-3 items-start">
                        <span className="w-2 h-2 rounded-full bg-emerald-400 flex-shrink-0 mt-1.5" />
                        <div>
                          <div style={cinzel} className="text-[12px] font-bold tracking-wide uppercase text-[#1a0f02] mb-1">{p.title}</div>
                          <p className="text-[13px] leading-[1.7] text-[#6b5535]">{p.desc}</p>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
                {/* CONS */}
                <div>
                  <div className="flex items-center gap-3 mb-5">
                    <div className="w-8 h-8 rounded-full bg-amber-50 border border-amber-200 flex items-center justify-center">
                      <svg width="14" height="14" viewBox="0 0 14 14" fill="none"><path d="M7 3v5M7 10v1" stroke="#d97706" strokeWidth="2" strokeLinecap="round"/></svg>
                    </div>
                    <span style={cinzel} className="text-[13px] font-bold uppercase tracking-[0.06em] text-[#1a0f02]">Disadvantages</span>
                  </div>
                  <div className="flex flex-col gap-3">
                    {PAGE.prosAndCons.cons.map((c, i) => (
                      <div key={i} className="bg-white border border-amber-100 rounded-xl p-4 flex gap-3 items-start">
                        <span className="w-2 h-2 rounded-full bg-amber-400 flex-shrink-0 mt-1.5" />
                        <div>
                          <div style={cinzel} className="text-[12px] font-bold tracking-wide uppercase text-[#1a0f02] mb-1">{c.title}</div>
                          <p className="text-[13px] leading-[1.7] text-[#6b5535]">{c.desc}</p>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <GoldDivider />

        {/* ══════════════════════════════════════
            POST-TRANSPLANT EXPECTATIONS
        ══════════════════════════════════════ */}
        <div className={`${wrap} ${sec}`}>
          <div ref={addSection}>
            <Eyebrow>After the Procedure</Eyebrow>
            <SectionHeading>What to Expect After Hair Transplant at Clinique Internationale?</SectionHeading>
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-5 max-w-4xl mx-auto">
              {PAGE.expectations.map((e, i) => (
                <div key={i} className="bg-white border border-[#c9a84c]/18 rounded-2xl p-6 flex gap-4 items-start relative overflow-hidden">
                  <span className="absolute top-0 left-4 right-4 h-px bg-gradient-to-r from-transparent via-[#c9a84c]/40 to-transparent" />
                  <div className="w-9 h-9 flex-shrink-0 rounded-full bg-gradient-to-br from-[#c9a84c]/15 to-[#c9a84c]/5 border border-[#c9a84c]/20 flex items-center justify-center">
                    <span style={cinzel} className="text-[11px] font-black text-[#c9a84c]">{String(i + 1).padStart(2, "0")}</span>
                  </div>
                  <p className="text-[13.5px] leading-[1.8] text-[#6b5535]">{e}</p>
                </div>
              ))}
            </div>
          </div>
        </div>

        {/* ══════════════════════════════════════
            FAQ
        ══════════════════════════════════════ */}
        <GoldDivider />
        <div className="bg-[#faf8f4] py-16 sm:py-20 md:py-24">
          <div className={wrap}>
            <div ref={addSection}>
              <Eyebrow>Common Questions</Eyebrow>
              <SectionHeading>Frequently Asked Questions</SectionHeading>
              <div className="max-w-3xl mx-auto flex flex-col gap-3">
                {PAGE.faqs.map((f, i) => <FaqItem key={i} q={f.q} a={f.a} />)}
              </div>
            </div>
          </div>
        </div>
        <GoldDivider />

        {/* ══════════════════════════════════════
            MISSION STRIP
        ══════════════════════════════════════ */}
        <div className="bg-[#0e0905] py-14 sm:py-16">
          <div className="max-w-3xl mx-auto px-5 sm:px-8 text-center">
            <p style={cinzel} className="text-[1rem] sm:text-[1.2rem] md:text-[1.4rem] font-light leading-[1.7] text-white/85 tracking-[0.02em]">
              "We combine <em className="italic" style={{ color: "#c9a84c" }}>surgical precision</em> with a deeply patient-centred philosophy because every transplant is a life-changing procedure that deserves nothing less than our absolute best."
            </p>
            <p className="text-[11px] tracking-[0.18em] uppercase text-[#c9a84c]/50 mt-5">Dr. Bhavesh Gupta, Founder · Clinique Internationale</p>
          </div>
        </div>

        {/* ══════════════════════════════════════
            SUCCESSFUL RESULTS / BEFORE-AFTER
        ══════════════════════════════════════ */}
        <GoldDivider />
        <div className="bg-[#faf8f4] py-16 sm:py-20 md:py-24">
          <div className={wrap}>
            <div ref={addSection}>
              <Eyebrow>{PAGE.results.eyebrow}</Eyebrow>
              <SectionHeading>{PAGE.results.heading}</SectionHeading>
              <p className="text-[14.5px] leading-[1.9] text-[#3a2e1e] max-w-3xl mx-auto text-center mb-10">{PAGE.results.sub}</p>
              <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
                {PAGE.results.cases.map((r, i) => (
                  <ResultCard key={i} r={r} onImageClick={(imgIdx) => openLightbox(i, imgIdx)} />
                ))}
              </div>
            </div>
          </div>
        </div>
        <GoldDivider />

        {/* ══════════════════════════════════════
            CTA
        ══════════════════════════════════════ */}
        <div className={`${wrap} ${sec}`}>
          <div ref={addSection} className="max-w-xl mx-auto text-center">
            <Eyebrow>{PAGE.cta.eyebrow}</Eyebrow>
            <h3 style={cinzel} className="font-black text-[1.3rem] sm:text-[1.65rem] md:text-[1.9rem] text-[#1a0f02] uppercase tracking-[0.06em] mb-3.5">{PAGE.cta.heading}</h3>
            <p className="text-[14px] text-[#6b5535] leading-[1.75] mb-8">{PAGE.cta.sub}</p>
            <div className="flex items-center justify-center gap-4 flex-wrap">
              <a href={PAGE.cta.primary.href}
                style={{ ...cinzel, backgroundImage: "linear-gradient(135deg,#c9943a,#ffe9a0,#c9943a)", backgroundSize: "200% 100%" }}
                className="text-[11px] font-bold tracking-[0.16em] uppercase px-8 py-3.5 rounded-md text-[#1a0f02] hover:-translate-y-0.5 hover:shadow-[0_8px_24px_rgba(201,168,76,0.35)] transition-all inline-block">
                {PAGE.cta.primary.label}
              </a>
              <a href={PAGE.cta.secondary.href}
                style={cinzel}
                className="text-[11px] font-bold tracking-[0.16em] uppercase px-8 py-[13px] rounded-md bg-transparent border border-[#1a0f02]/35 text-[#1a0f02] hover:-translate-y-0.5 hover:border-[#c9a84c] hover:text-[#a07828] transition-all inline-block">
                {PAGE.cta.secondary.label}
              </a>
            </div>
          </div>
        </div>

        
{/* HAIR TRANSPLANT LOCATIONS ACROSS INDIA */}
<GoldDivider />

<section className="bg-[#faf8f4] py-8 md:py-10">
  <div className={wrap}>
    <div ref={addSection}>
      <Eyebrow>Our Locations</Eyebrow>

      <SectionHeading>
        Hair Transplant Across India
      </SectionHeading>

      <p className="max-w-3xl mx-auto text-center text-[13.5px] sm:text-[14.5px] leading-[1.9] text-[#6b5535] mb-10">
        Explore hair transplant services in major cities across
        India. Choose your preferred location to learn more about
        hair restoration services available in your city.
      </p>

      <div className="grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-4 gap-5">
        {indiaLocationGroups.map((group) => (
          <div
            key={group.title}
            className="bg-white border border-[#c9a84c]/20 rounded-2xl p-5 sm:p-6 relative overflow-hidden"
          >
            <span className="absolute top-0 left-4 right-4 h-px bg-gradient-to-r from-transparent via-[#c9a84c]/50 to-transparent" />

            <h3
              style={cinzel}
              className="text-[12px] sm:text-[13px] font-bold tracking-[0.05em] uppercase text-[#1a0f02] mb-4 pb-3 border-b border-[#c9a84c]/20"
            >
              {group.title}
            </h3>

            <ul className="space-y-2.5">
              {group.locations.map((location) => (
                <li key={location.slug}>
                  <a
                    href="#" // {`/hair-transplant-in-${location.slug}`}
                    className="group flex items-start gap-2 text-[13px] sm:text-[14px] leading-relaxed text-[#6b5535] hover:text-[#a07828] transition-colors"
                  >
                    <span className="text-[#c9a84c] mt-px shrink-0">
                      →
                    </span>

                    <span className="group-hover:underline underline-offset-4">
                      Hair Transplant in {location.name}
                    </span>
                  </a>
                </li>
              ))}
            </ul>
          </div>
        ))}
      </div>
    </div>
  </div>
</section>

<GoldDivider />


      </div>

      {/* ── LIGHTBOX (portal-less, rendered at page root so it overlays everything) ── */}
      <ResultLightbox
        items={lightboxItems}
        activeIndex={activeIndex}
        onClose={closeLightbox}
        onNav={navLightbox}
      />
    </>
  );
}